import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2LightBulbIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21 20.546",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 20.546),
    children: [/*#__PURE__*/jsx("path", {
      d: "m13.228 15.759v2.471c0 1.3-1.091 1.818-2.727 1.818s-2.728-.524-2.728-1.818v-2.468"
    }), /*#__PURE__*/jsx("path", {
      d: "m12.773 15.954a5.76 5.76 0 0 0 3.64-5.454 5.909 5.909 0 0 0 -11.818 0 5.76 5.76 0 0 0 3.636 5.455z"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.773 17.772h5.455"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.5.5v1.818"
    }), /*#__PURE__*/jsx("path", {
      d: "m.5 9.591h2.083"
    }), /*#__PURE__*/jsx("path", {
      d: "m2.773 2.772 1.818 1.818"
    }), /*#__PURE__*/jsx("path", {
      d: "m20.5 9.591h-2.085"
    }), /*#__PURE__*/jsx("path", {
      d: "m18.228 2.772-1.818 1.818"
    }), /*#__PURE__*/jsx("path", {
      d: "m12.773 15.954a5.76 5.76 0 0 0 3.64-5.454 5.909 5.909 0 0 0 -11.818 0 5.76 5.76 0 0 0 3.636 5.455z"
    }), /*#__PURE__*/jsx("path", {
      d: "m11.15 6.614a3.993 3.993 0 0 1 2.93 2.19"
    })]
  });
};

export { PM2LightBulbIcon };
//# sourceMappingURL=light-bulb.js.map
